import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

import gettingStartedInstall from '@hotjar/shared-assets/images/getting-started/getting-started-install.jpg';

const StyledImage = styled.img`
  position: static;
  width: 100%;
  max-width: 424px;
  align-self: center;
  margin: auto 0 0;

  @media ${tokens.breakpoint.minWidth.s} {
    position: fixed;
    left: 0;
    bottom: 0;
  }
`;

export const TeamCollaboration = (): JSX.Element => {
  // eslint-disable-next-line global-require
  return <StyledImage src={gettingStartedInstall} />;
};
